<template>
  <div class="jurisd">
    <div class="auth-section">
      <div class="auth-content">
        <div class="lab" :class="{'active': it.isActive}" v-for="(it,idx) in authData.customerLevel" :key="'c'+idx" @click="handleActive(it)">
          <i class="el-icon-success"></i>{{it.value}}
        </div>
        <div class="lab" :class="{'active': it.isActive}" v-for="(it,idx) in authData.technicalServiceLevel" :key="'t'+idx" @click="handleActive(it)">
          <i class="el-icon-success"></i>{{it.value}}
        </div>
        <div class="lab" :class="{'active': it.isActive}" v-for="(it,idx) in authData.registerRole" :key="'r'+idx" @click="handleActive(it)">
          <i class="el-icon-success"></i>{{it.value}}
        </div>
        <div class="lab" :class="{'active': it.isActive}" v-for="(it,idx) in authData.insideStaff" :key="'i'+idx" @click="handleActive(it)">
          <i class="el-icon-success"></i>{{it.value}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customerLevelApi from '@/api/sys/customerLevel'
import sysRoleApi from '@/api/sys/sysRole'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isAjax: 0,
      authData: {
        customerLevel: [],
        registerRole: [],
        technicalServiceLevel: [],
        insideStaff: [{ key: 1, value: '内部员工' }]
      }
    }
  },
  watch: {
    value: {
      handler(newVal) {
        // 当value变化时，重新初始化选中状态
        if (this.isAjax === 3) {
          this.initActiveItems()
        }
      },
      deep: true
    }
  },
  created() {
    this.getCustomerLevel()
    this.getRegisterRole()
    this.getTechnicalServiceLevel()
  },
  methods: {
    getCustomerLevel() {
      customerLevelApi.fetchList().then(({ data }) => {
        let arr = []
        data.forEach(item => {
          arr.push({ value: item.name, key: item.id, isActive: false })
        })
        this.authData.customerLevel = arr
        this.isAjax++
        this.checkAndInitActive()
      })
    },
    getTechnicalServiceLevel() {
      technicalServiceLevelApi.findOptions().then(({ data }) => {
        this.authData.technicalServiceLevel = data.map(item => ({
          ...item,
          isActive: false
        }))
        this.isAjax++
        this.checkAndInitActive()
      })
    },
    getRegisterRole() {
      sysRoleApi.fetchList({ pageNo: 1, pageSize: 1000, roleType: 2 }).then(({ data }) => {
        let arr = []
        data.list.forEach(item => {
          arr.push({ value: item.roleName, key: item.id, isActive: false })
        })
        this.authData.registerRole = arr
        this.isAjax++
        this.checkAndInitActive()
      })
    },
    checkAndInitActive() {
      if (this.isAjax === 3) {
        this.initActiveItems()
      }
    },
    initActiveItems() {
      // 先清除所有的isActive状态，避免状态污染
      this.authData.customerLevel.forEach(item => { item.isActive = false })
      this.authData.technicalServiceLevel.forEach(item => { item.isActive = false })
      this.authData.registerRole.forEach(item => { item.isActive = false })
      this.authData.insideStaff.forEach(item => { item.isActive = false })

      if (!this.value || this.value.length === 0) {
        this.$forceUpdate()
        return
      }

      this.value.forEach(item => {
        let key = item.levelSource === 1 ? 'customerLevel' :
                  (item.levelSource === 2 ? 'technicalServiceLevel' :
                  (item.levelSource === 3 ? 'registerRole' : 'insideStaff'))

        let list = this.authData[key]
        let find = list.find(it => it.key === item.levelId)
        if (find) {
          find.isActive = true
        }
      })
      this.$forceUpdate()
    },
    handleActive(it) {
      it.isActive = !it.isActive
      this.$forceUpdate()
      this.emitChange()
    },
    emitChange() {
      const selected = []
      this.authData.customerLevel.forEach(item => {
        if (item.isActive) {
          selected.push({
            authType: 1,
            levelSource: 1,
            levelId: item.key
          })
        }
      })

      this.authData.technicalServiceLevel.forEach(item => {
        if (item.isActive) {
          selected.push({
            authType: 1,
            levelSource: 2,
            levelId: item.key
          })
        }
      })

      this.authData.registerRole.forEach(item => {
        if (item.isActive) {
          selected.push({
            authType: 1,
            levelSource: 3,
            levelId: item.key
          })
        }
      })

      this.authData.insideStaff.forEach(item => {
        if (item.isActive) {
          selected.push({
            authType: 1,
            levelSource: 4,
            levelId: item.key
          })
        }
      })

      this.$emit('input', selected)
      this.$emit('change', selected)
    },

    getSelectedAuths() {
      const selected = []

      this.authData.customerLevel.forEach(item => {
        if (item.isActive) {
          selected.push({
            authType: 1,
            levelSource: 1,
            levelId: item.key
          })
        }
      })

      this.authData.technicalServiceLevel.forEach(item => {
        if (item.isActive) {
          selected.push({
            authType: 1,
            levelSource: 2,
            levelId: item.key
          })
        }
      })

      this.authData.registerRole.forEach(item => {
        if (item.isActive) {
          selected.push({
            authType: 1,
            levelSource: 3,
            levelId: item.key
          })
        }
      })

      this.authData.insideStaff.forEach(item => {
        if (item.isActive) {
          selected.push({
            authType: 1,
            levelSource: 4,
            levelId: item.key
          })
        }
      })

      return selected
    }
  }
}
</script>

<style scoped lang="scss">
.jurisd {
  .auth-section {
    margin-bottom: 20px;
  }

  .auth-label {
    margin-bottom: 12px;
    font-size: 14px;
    color: #606266;
    font-weight: 500;

    .required-mark {
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .auth-content {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .lab {
    position: relative;
    display: inline-block;
    padding: 8px 16px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;
    user-select: none;

    i {
      position: absolute;
      top: -6px;
      right: -6px;
      font-size: 16px;
      background: #67c23a;
      color: #fff;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s;
      transform: scale(0);
      opacity: 0;
    }

    &:hover {
      border-color: #409eff;
      color: #409eff;
    }

    &.active {
      background-color: #409eff;
      border-color: #409eff;
      color: #fff;

      i {
        transform: scale(1);
        opacity: 1;
      }
    }
  }
}
</style>
